import React from "react";

import { PropsWithChildren } from "react";
import { styled } from "@mui/material";

const StyledMain = styled("main")`
  width: 100%;
  min-height: 100%;
  overflow: auto; /* 恢复为auto以保持滚动功能 */
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`;

export const Main = ({ children }: PropsWithChildren<unknown>) => <StyledMain>{children}</StyledMain>;
